import { render, staticRenderFns } from "./ServiceRule.vue?vue&type=template&id=c1767742&scoped=true"
import script from "./ServiceRule.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceRule.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ServiceRule.vue?vue&type=style&index=0&id=c1767742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1767742",
  null
  
)

export default component.exports